import {useInfiniteQuery, type UseInfiniteQueryOptions} from 'react-query';
import {fetchNotifications, type NotificationsResponse} from '../../http/notifications/fetchNotifications';
import {notificationsListQueryKey} from './queryKeys';

const PAGE_SIZE = 20;

export function useFetchNotifications(options?: UseInfiniteQueryOptions<NotificationsResponse>) {
	return useInfiniteQuery<NotificationsResponse>({
		queryKey: notificationsListQueryKey,
		queryFn: async ({pageParam = 1, signal}) => {
			const {data} = await fetchNotifications({page: pageParam, per_page: PAGE_SIZE}, signal);

			return data;
		},
		getNextPageParam: (lastPage) => {
			const currentPage = lastPage.meta?.current ?? 1;
			const lastPageNumber = lastPage.meta?.last ?? currentPage;

			if (currentPage >= lastPageNumber) return undefined;

			return currentPage + 1;
		},
		retry: false,
		...options,
	});
}
